import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// AdapterDayjs needs both of these before it will honour a `timezone` prop.
// `extend` is idempotent, so importing this from more than one place is safe.
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * The venue's clock. JEPX trades on Japan Standard Time, so absolute times are
 * entered and read in Tokyo rather than in whatever zone the desk happens to be
 * sitting in. JST has no DST, so this is a fixed +09:00.
 *
 * Only presentation: values stay absolute instants, and everything sent to
 * lazerhub is still serialised through `toISOString`.
 */
export const EXCHANGE_TIMEZONE = "Asia/Tokyo";
